// Pure formulas shared by the browser and Node tests. All monetary values are ARS.
function finite(value, name, min, max = 1e12) {
  if (!Number.isFinite(value) || value < min || value > max)
    throw new RangeError(`${name}: ingresá un número entre ${min} y ${max}.`);
  return value;
}
function odds(value) {
  if (!Number.isFinite(value) || value <= 1 || value > 1000000)
    throw new RangeError(
      'Las cuotas deben ser mayores que 1 y no superar 1.000.000.'
    );
  return value;
}
export function parseDecimal(value) {
  const normalized = String(value)
    .trim()
    .replace(/[ \u00a0\u202f]/g, '')
    .replace(',', '.');
  if (!/^\d+(?:\.\d+)?$/.test(normalized))
    throw new RangeError(
      'Completá todos los campos con números. Usá coma o punto como separador decimal.'
    );
  const number = Number(normalized);
  if (!Number.isFinite(number))
    throw new RangeError('Ingresá un valor numérico finito.');
  return number;
}
export function payout(stake, coefficient) {
  finite(stake, 'Monto', 0);
  odds(coefficient);
  return {
    payout: stake * coefficient,
    profit: stake * (coefficient - 1),
    stake,
    loss: stake,
    implied: 100 / coefficient,
  };
}
export function kelly(bankroll, coefficient, probability, fraction = 0.25) {
  finite(bankroll, 'Bankroll', 0);
  odds(coefficient);
  finite(probability, 'Probabilidad (%)', 0, 100);
  if (![0.25, 0.5, 1].includes(fraction))
    throw new RangeError('Elegí cuarto Kelly, medio Kelly o Kelly completo.');
  const fullPercent = Math.max(
    0,
    ((probability / 100) * coefficient - 1) / (coefficient - 1)
  );
  const full = bankroll * fullPercent;
  return {
    amount: full * fraction,
    percent: fullPercent * fraction * 100,
    full,
    half: full / 2,
    quarter: full / 4,
    hasEdge: fullPercent > 0,
  };
}
